import { Component, Input, OnInit } from '@angular/core';
import { PopupsManagerService } from '../../services/popups-manager.service';
import { ComplexWallItem } from '../../common/types/wall-item';
import { BasePopupComponent } from '../../common/base/base-popup.component';
import { AuthService } from '../../services/auth.service';
import { CommonService } from '../../services/common.service';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import {
  PurchaseInfoPopupComponent,
  PurchaseInfoType,
} from '../purchase-info-popup/purchase-info-popup.component';
import { of, zip } from 'rxjs';
import { TilesService } from '../../services/tiles.service';
import { PurchaseFlowComponent } from '../purchase-flow/purchase-flow.component';
import { PurchaseFlowSteps } from '../../common/enums/purchaseFlow';

@Component({
  selector: 'app-nft-information',
  templateUrl: './nft-information.component.html',
  styleUrls: ['./nft-information.component.scss'],
})
export class NftInformationComponent
  extends BasePopupComponent
  implements OnInit
{
  @Input() nftInfo!: ComplexWallItem;

  public isCartItem: boolean | undefined;
  public canReport: boolean | undefined;
  public canEdit: boolean | undefined;

  constructor(
    public authService: AuthService,
    public tilesService: TilesService,
    public commonService: CommonService,
    popupsManagerService: PopupsManagerService
  ) {
    super(popupsManagerService);
  }

  ngOnInit(): void {
    this.canReport = this.authService.publicId !== this.nftInfo.tiles[0].userId;
    zip(this.tilesService.wallItems$, this.tilesService.cartItems$)
      .pipe(takeUntil(this.destroy$))
      .subscribe(([wallItems, cartItems]) => {
        if (this.authService.publicId === this.nftInfo.tiles[0].userId) {
          this.isCartItem =
            cartItems.findIndex(
              (cartItem) => cartItem.tiles[0].id === this.nftInfo.tiles[0].id
            ) !== -1;
        }
        const allItems = [...wallItems, ...cartItems];
        this.canEdit =
          this.authService.publicId === this.nftInfo.tiles[0].userId &&
          allItems.some(
            (item) => item.tiles[0].id === this.nftInfo.tiles[0].id
          );
      });
  }

  public reportHandler(): void {
    let type: PurchaseInfoType = PurchaseInfoType.Success;
    let text: string = 'You reported this nft';
    this.commonService
      .reportNft(this.nftInfo?.tiles[0]?.id)
      .pipe(
        takeUntil(this.destroy$),
        catchError(() => {
          type = PurchaseInfoType.Error;
          text = 'Something went wrong';
          return of(null);
        }),
        tap(() => {
          this.closePopup();
          this.popupsManagerService.show(PurchaseInfoPopupComponent, {
            inputs: {
              type,
              info: {
                text,
              },
            },
            className: 'overlay',
          });
        })
      )
      .subscribe();
  }

  public editHandler(): void {
    this.closePopup();
    this.popupsManagerService.show(PurchaseFlowComponent, {
      inputs: {
        currentStep: PurchaseFlowSteps.EditImage,
        wallItem: this.nftInfo,
        isCartItem: this.isCartItem,
      },
    });
  }
}
